export function parseError(error: any) {
  const defaultError = 'Something went wrong';
  let reason = null;
  if (typeof error === 'object' && error.reason) {
    reason = error.reason;
  }
  if (typeof error === 'string' && error.length > 0) {
    reason = error;
  }
  return reason ? { message: defaultError + ': ' + reason } : { message: defaultError };
}
